<template>
	<p>{{expert.name}}</p>
</template>


<script>
export default {
	name: 'ExpertserviceExperts',
	props: ["expert"]
}
</script>
